import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services';
import {DEFAULT_ERROR_MESSAGE} from '../global';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 401 && !request.url.match('/auth/login')
          && !request.urlWithParams.endsWith('/auth/user-identity/change-password')) {
          this.auth.logout();
          location.reload();
        }

        if (request.url.match('business-irdgco-dispatch.cloudintercorpretail')) {
          let errorMsg = (err.error && err.error.messageDetail) || (err.error && err.error.message);

          if (errorMsg == null) {
            errorMsg = DEFAULT_ERROR_MESSAGE;
          }

          return throwError(errorMsg);
        }

        if (request.url.match('business-irdgco-picking.cloudintercorpretail')) {
          let errorMsg = err.error
          if (errorMsg == null) {
            errorMsg = DEFAULT_ERROR_MESSAGE;
          }
            
          return throwError(errorMsg);
        }

        let error = (err.error && err.error.message) || err.statusText || err;

        if (error === 'Unknown Error') {
          error =
            'Se ha producido un error inesperado. Vuelva a intentarlo por favor.';
        }
        return throwError(err);
      })
    );
  }
}
